<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <DefectForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DefectForm from '@/components/organisms/master/form/DefectForm'

export default {
  name: 'DefectPage',

  components: {
    DefectForm,
  },
}
</script>
